import Api from './Api';
import Configuracao from '../util/Configuracao';

class ItemTabelaApi extends Api {
  async consultarTabelas () {
    try {
      const urlConsultarTabelas = Configuracao.getConfiguracao().urlConsultarTabelas;
      const response = await this.fetch(urlConsultarTabelas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTiposDeItem () {
    try {
      const urlConsultarTiposDeItem = Configuracao.getConfiguracao().urlConsultarTiposDeItem;
      const response = await this.fetch(urlConsultarTiposDeItem);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarItens (codTabela, codItem, desItem, codTipo, indApenasUnimed) {
    try {
      const urlConsultarItens = Configuracao.getConfiguracao().urlConsultarItens +
      codTabela + '/' +
      codItem + '/' +
      desItem + '/' +
      codTipo + '/' +
      indApenasUnimed;
      const response = await this.fetch(urlConsultarItens);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default ItemTabelaApi;
